import { makeStyles, Theme } from '@material-ui/core';

type Props = {
  isLoading: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
    '& .MuiTypography-button': {
      display: 'flex',
    },
  },
  icon: {
    float: 'left',
  },
  text: (props: Props) => ({
    color: props.isLoading ? theme.palette.neutral.dark : theme.palette.primary.main,
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'flex',
  }),
}));

export default useStyles;
